import { Icon } from '@iconify/react';
import { Divider, IconButton, Stack } from '@mui/material';
import arrowUpFill from '@iconify/icons-eva/arrow-up-fill';
import arrowDownFill from '@iconify/icons-eva/arrow-down-fill';
import React, { useMemo } from 'react';
import { RootStyle } from './style';

interface IProps {
  row: IChallengeRoutines;
  nextOrderRoutine: (row: IChallengeRoutines) => void;
  prevOrderRoutine: (row: IChallengeRoutines) => void;
  routine: IChallengeRoutines[];
}

export function RoutineOrderComponent({
  row,
  nextOrderRoutine,
  prevOrderRoutine,
  routine,
}: IProps) {
  const onClickPrev = () => {
    prevOrderRoutine(row);
  };

  const onClickNext = () => {
    nextOrderRoutine(row);
  };

  const isFirstRow = useMemo(() => {
    return (
      routine.filter((v: IChallengeRoutines) => v.date === row.date)[0].id ===
      row.id
    );
  }, [routine, row]);

  const isLastRow = useMemo(() => {
    const filter = routine.filter(
      (v: IChallengeRoutines) => v.date === row.date,
    );
    return filter[filter.length - 1].id === row.id;
  }, [routine, row]);

  return (
    <Stack direction='row' sx={{ height: '100%', padding: '3px 0px' }}>
      <IconButton
        size='small'
        sx={{ mr: 1 }}
        onClick={onClickNext}
        disabled={isLastRow}
      >
        <Icon icon={arrowDownFill} color='#a8a8a8' />
      </IconButton>
      <Divider orientation='vertical' flexItem />
      <IconButton
        size='small'
        sx={{
          mr: 1,
          ml: 1,
        }}
        onClick={onClickPrev}
        disabled={isFirstRow}
      >
        <Icon icon={arrowUpFill} color='#a8a8a8' />
      </IconButton>
    </Stack>
  );
}
